import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_AES_KEY;

const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  } catch (error) {
    console.error("error: failed encrypting data: ", error);
    return null;
  }
};

const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("error: failed decrypting data: ", error);
    return null;
  }
};

const encodeData = (value) => {
  try {
    if (!value) return undefined;
    return encodeURIComponent(window.btoa(JSON.stringify(value)));
  } catch (error) {
    console.error("error: failed encoding data: ", error);
    return undefined;
  }
};

const decodeData = (value) => {
  try {
    if (!value) return undefined;
    return JSON.parse(window.atob(decodeURIComponent(value)));
  } catch (error) {
    console.error("error: failed decoding data: ", error);
    return undefined;
  }
};

export default {
  encryptData,
  decryptData,
  encodeData,
  decodeData,
};
